import { getAppsyncUrl } from "../authenticate";
import { getAuth } from '../../contexts/authStore';
import { getUserPool } from "../pools/pools";

export async function getUserPaymentMethod(userId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                getUserPaymentMethod(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getUserPaymentMethod)
            })
        })
    }
}

export async function getClientToken(userId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                getClientToken(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getClientToken)
            })
        })
    }
}

export async function getCustomer(userId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                getCustomer(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getCustomer)
            })
        })
    }
}

export async function getTransactions(userId: string, limit: number) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                    getTransactions(userId: ${JSON.stringify(userId)}, limit: ${limit})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getTransactions)
            })
        })
    }
}

export async function getTransaction(userId: string, transactionId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                    getTransaction(userId: ${JSON.stringify(userId)}, transactionId: ${JSON.stringify(transactionId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getTransaction)
            })
        })
    }
}

export async function getSubscription(userId: string, subscriptionId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                    getSubscription(userId: ${JSON.stringify(userId)}, subscriptionId: ${JSON.stringify(subscriptionId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getSubscription)
            })
        })
    }
}

export async function putSubscription(userId: string, paymentMethodToken: string, planId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                putSubscription(userId: ${JSON.stringify(userId)}, paymentMethodToken: ${JSON.stringify(paymentMethodToken)}
                , planId: ${JSON.stringify(planId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putSubscription)
            })
        })
    }
}

export async function createCustomer(userId: string, name: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                createCustomer(userId: ${JSON.stringify(userId)}, name: ${JSON.stringify(name)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.createCustomer)
            })
        })
    }
}

export async function updateSubscription(userId: string, paymentMethodToken: string, subscriptionId: string, newPlanId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                updateSubscription(userId: ${JSON.stringify(userId)}, paymentMethodToken: ${JSON.stringify(paymentMethodToken)}
                , subscriptionId: ${JSON.stringify(subscriptionId)}, newPlanId: ${JSON.stringify(newPlanId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.updateSubscription)
            })
        })
    }
}

export async function cancelSubscription(userId: string, subscriptionId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                cancelSubscription(userId: ${JSON.stringify(userId)}, subscriptionId: ${JSON.stringify(subscriptionId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.cancelSubscription)
            })
        })
    }
}

export async function deletePaymentMethod(userId:string, paymentToken: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                deletePaymentMethod(userId: ${JSON.stringify(userId)}, paymentToken: ${JSON.stringify(paymentToken)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.deletePaymentMethod)
            })
        })
    }
}